import {Injectable} from '@angular/core';
import {ApiClientService} from "../api-client/api-client.service";
import {Config} from '../../models/config';
import {ApiResponse} from '../../api/api-response';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(
    private apiClient: ApiClientService) {
  }

  load(): Observable<Config> {
    return new Observable<Config>(subscriber => {
      this.apiClient.get('/config').subscribe({
        next: (response: ApiResponse) => {
          let config = new Config().deserialize(response.getData());
          subscriber.next(config);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
